import { render, staticRenderFns } from "./GuiasImprimirAnexos.vue?vue&type=template&id=4328218d&"
import script from "./GuiasImprimirAnexos.vue?vue&type=script&lang=js&"
export * from "./GuiasImprimirAnexos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports